import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable()
export class LocalTimeService {
    public now(): moment.Moment {
        return moment();
    }
}
